import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { cfpBaseUrl } from '../../network/urls';


const initialState = {
    data: [],
    currentPage: 1,
    pageSize: 20,
    dateFrom: '',
    dateTo: '',
    applicationProgressId: '',
    objectionStatus: '',
    totalPages: null,
    totalRecords: null,
    isLoading: false,
    error: null,
}

// Define an async thunk for fetching paginated data
export const fetchPaginatedBillInstallmentNormal = createAsyncThunk(
    'generalServices/fetchBillInstallmentNormal',
    async ({ page, pageSize, dateFrom, dateTo, applicationProgressId, objectionStatus }, { getState }) => {
        const { auth } = getState();
        const { token, code, hierarchy, showAllApplicationsFlag, csc } = auth;

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const formdata = new FormData();
        formdata.append("pageNumber", page);
        formdata.append("pageSize", pageSize);
        formdata.append("officeCode", csc);
        formdata.append("officeLevel", hierarchy);
        formdata.append("showAllApplicationFlag", showAllApplicationsFlag);
        formdata.append("overDueFlag", 0);
        formdata.append("dateFrom", dateFrom);
        formdata.append("dateTo", dateTo);
        formdata.append("applicationProgressId", applicationProgressId);
        formdata.append("objectionStatus", objectionStatus);

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };

        const response = await fetch(cfpBaseUrl + `comman/getAllBillInstallmentApplications`, requestOptions);
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Stats API issue!');
        }

        const result = await response.json();

        if (result.status !== "200" && result.status !== "400") {
            throw new Error(result.message, 'printing error message' || 'Unable to fetch stats!');
        }

        return result;
    }
);

const billInstallmentNormalPaginatedSlice = createSlice({
    name: 'billInstallmentNormalPaginated',
    initialState: initialState,
    reducers: {
        nextPage(state) {
            state.currentPage += 1;
        },
        previousPage(state) {
            if (state.currentPage > 1) {
                state.currentPage -= 1;
            }
        },
        filterProgressId(state, action) {
            state.applicationProgressId = action.payload
        },
        resetProgressIdFilter(state) {
            state.applicationProgressId = ''
        },
        filterObjectionStatus(state, action) {
            state.objectionStatus = action.payload
        },
        resetObjectionStatusFilter(state) {
            state.applicationProgressId = ''
        },
        filterDateFrom(state, action) {
            state.dateFrom = action.payload
        },
        filterDateTo(state, action) {
            state.dateTo = action.payload
        },
        resetDateFilter(state) {
            state.dateFrom = ''
            state.dateTo = ''
        },
        firstPage(state) {
            state.currentPage = 1;
        },
        lastPage(state, action) {
            state.currentPage = action.payload;
        },
        resetState(state) {
            state.data = [];
            state.currentPage = 1;
            state.isLoading = false;
            state.error = null;
            state.pageSize = 20;
            state.dateFrom = ''
            state.dateTo = ''
            state.applicationProgressId = ''
            state.objectionStatus = ''
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPaginatedBillInstallmentNormal.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchPaginatedBillInstallmentNormal.fulfilled, (state, action) => {
                state.isLoading = false;
                if (action.payload.data) {
                    state.data = action.payload.data;
                } else {
                    state.data = []
                }
                if (action.payload.totalPages) {
                    state.totalPages = action.payload.totalPages;
                } else {
                    state.totalPages = 1
                }
                state.totalRecords = action.payload.totalRecords;
                state.error = null;
            })
            .addCase(fetchPaginatedBillInstallmentNormal.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
                state.totalPages = null;
                state.totalRecords = null;
            });
    },
});

export const { nextPage, previousPage, firstPage, lastPage, filterProgressId, filterObjectionStatus, filterDateFrom, filterDateTo, resetProgressIdFilter, resetObjectionStatusFilter, resetDateFilter, resetState } = billInstallmentNormalPaginatedSlice.actions;

export default billInstallmentNormalPaginatedSlice.reducer;
